<template xmlns:color="http://www.w3.org/1999/xhtml">
  <div class="row">
    <!--  申请用户信息  -->
    <div class="flex xs10 offset--xs1">
      <va-card title="申请用户信息">
        <div class="row">
          <div class="flex md6 sm6 xs12">
            <va-input
              label="学员uid"
              v-model="insertData.user.uid"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              label="学员姓名"
              v-model="insertData.user.nickname"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="申请提交时间"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.status"
              label="处理状态"
              :options="statusOptions"
              no-clear
            />
          </div>
        </div>
        <div class="row justify--center">
          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="processAppliedCourse" :disabled="!submitButtonStatus">
              保存
            </va-button>
          </div>
          <div class="flex md2">
            <va-button class="ma-0" color="gray" slot="trigger" @click="$router.push({ name: 'listAppliedCourse' })">
              返回
            </va-button>
          </div>
          <div class="flex md2">
            <va-button class="ma-0" color="primary" slot="trigger" @click="$router.push({ path: `/admin/users/updateUser/${insertData.user.uid}` })">
              查看用户信息
            </va-button>
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="课程信息">
        <div class="row">
          <div class='flex md12 sm6 xs12' >
            <va-card
              overlay
              :image='insertData.course.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.course.id'
              label='id'
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="serviceType"
              label="课程类型"
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.course.name"
              label="课程名称"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <label for="course-desc">课题介绍/项目简介:</label>
            <vue-trix
              v-model="insertData.course.description"
              label="介绍"
              disabled-editor
              id="course-desc"
            />
          </div>

        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject, formatTime } from '../../../utils/common'
import appliedCourseApi from '../../../api/appliedCourse'
import { APPLIED_SERVICE_TYPES, USER_APPLICATION_STATUS_TYPES } from '../../../utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        serviceType: null,
        createTime: '',
        course: {},
        user: {},
        status: null,
      },
      message: ['Required field'],
      title: '',
      statusOptions: USER_APPLICATION_STATUS_TYPES.map(x => { return x.TEXT }),
      submitButtonStatus: true,
      coursePath: '',
      serviceType: '',
    }
  },
  created () {
    this.getAppliedCourse()
  },
  computed: {

  },
  methods: {
    getAppliedCourse () {
      const params = this.$route.params
      if (params.id != null) {
        this.title = '申请职位详情'
        // 通过id获取详情
        appliedCourseApi.getAppliedCourse(params.id).then(response => {
          copyObject(response.appliedCourse, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          this.computeCodeToServiceType(response.appliedCourse.serviceType)
          this.computeCodeToStatus(response.appliedCourse.status)
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    processAppliedCourse () {
      this.changeButtonStatus(false)
      const data = {
        id: this.insertData.id,
        status: this.computeStatusToCode(this.insertData.status),
      }
      appliedCourseApi.processAppliedCourse(data.id, data).then(response => {
        if (response.success === true) {
          this.changeButtonStatus(true)
          this.showToast('更新处理状态成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.getAppliedCourse()
        }
      }).catch(error => {
        this.changeButtonStatus(true)
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computeCodeToStatus (code) {
      USER_APPLICATION_STATUS_TYPES.map(x => {
        if (x.CODE === code) {
          this.insertData.status = x.TEXT
        }
      })
    },
    computeStatusToCode (status) {
      let code = -1
      USER_APPLICATION_STATUS_TYPES.map(x => {
        if (x.TEXT === status) {
          code = x.CODE
        }
      })
      return code
    },
    computeCodeToServiceType (serviceType) {
      APPLIED_SERVICE_TYPES.map(x => {
        if (x.CODE === serviceType) {
          this.coursePath = x.COURSE_PATH
          this.serviceType = x.TEXT
        }
      })
    },
    computeCoursePath () {

    },
    resetStatus () {
    },
    clickCancel () {
    },
    checkField () {
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
